import { useTranslation } from 'react-i18next';
import { SOCIALS_MAP } from "shared/data/socialMedia";

export function SocialLinksSection() {
  const { t } = useTranslation();

  const socials = Object.values(SOCIALS_MAP)

  return (
    <section className="px-6 lg:px-24 py-12">
      <div className="flex flex-wrap justify-center gap-12 lg:gap-24 opacity-80 max-w-7xl mx-auto">
        {socials.map((platform) => (
          <a
            key={platform.label}
            href={platform.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-4 transition-all"
          >
            <div className="w-20 h-20 rounded-full bg-surface-container-high border border-tertiary/20 flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:shadow-tertiary/10 transition-all duration-500 text-tertiary">
              {platform.icon}
            </div>
            <span className="font-sans text-xs uppercase tracking-widest text-on-surface-variant group-hover:text-tertiary transition-colors">
              {platform.label}
              <span className="sr-only">{t('a11y.opensInNewTab')}</span>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
